import { Grid, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { useAutoTranslation } from 'src/hooks/useTranslate';

function PedigreeDates({ dateModified, theme, showPrintDate = true }) {
  if (!theme.dateFormat) theme = { dateFormat: 'MM/DD/YYYY' };
  const t = useAutoTranslation();

  const labels = {
    created: t('Created'),
    modified: t('Modified'),
    printDate: t('Print Date')
  };

  const rows = [
    { label: labels.created, date: dateModified?.created },
    { label: labels.modified, date: dateModified?.updated },
    ...(showPrintDate ? [{ label: labels.printDate, date: new Date() }] : [])
  ];

  return (
    <Grid container sx={{ px: 2 }}>
      {rows.map(({ label, date }, index) => (
        <Grid container direction="row" key={index} size={12}>
          <Typography
            component="div"
            style={{
              fontSize: '0.8rem',
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between'
            }}
          >
            <span style={{ color: '#777' }}>{label}:</span>
            <span>{date ? moment(date).format(theme.dateFormat) : '—'}</span>
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
}

export default PedigreeDates;
